// src/componentes/AppLayout/SidebarGroup.jsx
//
// Grupo colapsable (acordeón) del sidebar. Renderiza un header clickable con
// chevron + los ítems hijos. Si no hay ítems visibles, no renderiza nada
// (ej. un cobrador no ve el grupo "Admin" completo).

import React from "react";
import { NavLink } from "react-router-dom";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";

const SidebarGroup = ({ group, items, isOpen, onToggle, navClass }) => {
  if (!items.length) return null;

  const GroupIcon = group.icon;

  return (
    <li className={`sidebar-group ${isOpen ? "open" : ""}`}>
      <button
        type="button"
        className="sidebar-group-header"
        onClick={() => onToggle(group.id)}
        aria-expanded={isOpen}
      >
        <span className="sidebar-group-title">
          {GroupIcon && <GroupIcon />} {group.label}
        </span>
        {isOpen ? <FaChevronDown className="chev" /> : <FaChevronRight className="chev" />}
      </button>

      {isOpen && (
        <ul className="sidebar-group-items">
          {items.map((item) => {
            const Icon = item.icon;
            return (
              <li key={item.id}>
                <NavLink to={item.route} className={navClass}>
                  {Icon && <Icon />} {item.label}
                </NavLink>
              </li>
            );
          })}
        </ul>
      )}
    </li>
  );
};

export default SidebarGroup;
